import React from "react";

import * as S from "../styles";

import IProps from "./props";

import PlanFeatureMobile from "./plan-feature-mobile";

import { calculateClassName } from "./utils/calculate-class-name";

const PlanCardMobile: React.FC<IProps> = ({ plan, onSubmit, index }) => (
  <S.Card>
    <S.Header>
      <S.PlanName className={calculateClassName(index, "middle")}>
        {plan.name}
      </S.PlanName>
      <S.PlanPrice className={calculateClassName(index, "middle")}>
        {plan.price}
      </S.PlanPrice>
    </S.Header>
    {plan.features.map((feature, indexPlan) => (
      <PlanFeatureMobile key={indexPlan} feature={feature} index={index} />
    ))}
    <S.MobileButton
      onClick={onSubmit}
      className={calculateClassName(index, "invert-color")}
    >
      Quero este plano
    </S.MobileButton>
  </S.Card>
);

export default PlanCardMobile;
